import * as React from 'react';

export const useFirstRowWidth = (ref: React.RefObject<HTMLDivElement | null>, gap: number = 0): number | undefined => {
  const [firstRowWidth, setFirstRowWidth] = React.useState<number | undefined>();
  const resizeObserverRef = React.useRef<ResizeObserver | null>(null);

  const calculateFirstRowWidth = React.useCallback(() => {
    if (!ref.current || ref.current.children.length === 0) {
      setFirstRowWidth(undefined);

      return;
    }

    const children = Array.from(ref.current.children) as HTMLElement[];
    let currentRowTop: number | null = null;
    let calculatedWidth = 0;

    children.forEach((child, index) => {
      const rect = child.getBoundingClientRect();

      if (currentRowTop === null) {
        currentRowTop = rect.top;
      }

      if (rect.top === currentRowTop) {
        calculatedWidth += rect.width;

        if (index < children.length - 1 && children[index + 1].getBoundingClientRect().top === currentRowTop) {
          calculatedWidth += gap;
        }
      }
    });

    setFirstRowWidth(calculatedWidth);
  }, [ref, gap]);

  React.useEffect(() => {
    calculateFirstRowWidth();

    if (ref.current) {
      resizeObserverRef.current = new ResizeObserver(() => {
        calculateFirstRowWidth();
      });

      resizeObserverRef.current.observe(ref.current);
    }

    return () => {
      resizeObserverRef.current?.disconnect();
    };
  }, [ref, gap]);

  return firstRowWidth;
};
